import React from 'react';
import { Link } from 'react-router-dom';

interface NavItemProps {
  to: string;
  label: string;
}

const NavItem: React.FC<NavItemProps> = ({ to, label }) => {
  return (
    <li className="inline-block px-5">
      <Link className="text-white no-underline hover:underline" to={to}>
        {label}
      </Link>
    </li>
  );
};

export default NavItem;